module.exports = __webpack_public_path__ + "assets/a-12-huxi.97452a25.svg";